import { NegoziazioneAssistita, ParentVM, SectionVM } from 'civil-status/view-models/step-form';

export const transformerNegoziazioneAssistita = (
  idEvento?: number,
  dataSection?: SectionVM,
  dataTranscriptionNegoz?: SectionVM,
  dataDatiProvvedimento?: SectionVM,
  subjectAvvoc3?: ParentVM,
  subjectAvvoc4?: ParentVM,
  subjectAvvoc5?: ParentVM
): NegoziazioneAssistita | undefined => {
  if (
    !(
      dataSection ||
      dataTranscriptionNegoz ||
      dataDatiProvvedimento ||
      subjectAvvoc3 ||
      subjectAvvoc4 ||
      subjectAvvoc5
    )
  ) {
    return undefined;
  }

  return {
    key: {
      idEvento: idEvento || undefined,
    },
    accordo: dataSection?.typeAgreement || undefined,
    provvedimento: dataSection?.typeMeasure || undefined,
    ricezioneAtto: dataSection?.receiptDocument || undefined,
    dataStipulaAccordo: dataTranscriptionNegoz?.dateStipulation
      ? dataTranscriptionNegoz?.dateStipulation.toFormat('yyyy-MM-dd')
      : undefined,
    trascrizioneAccordo: dataTranscriptionNegoz?.templateTranscriptionText || undefined,
    dataDepositoProvvedimento: dataDatiProvvedimento?.depositDate
      ? dataDatiProvvedimento?.depositDate.toFormat('yyyy-MM-dd')
      : undefined,
    dataComunicazProvvedimento: dataDatiProvvedimento?.dateCommunication
      ? dataDatiProvvedimento?.dateCommunication.toFormat('yyyy-MM-dd')
      : undefined,
    foroAvvConiuge1:
      subjectAvvoc3?.generality?.lawyerForum || subjectAvvoc5?.generality?.lawyerForum || undefined,
    foroAvvConiuge2: subjectAvvoc4?.generality?.lawyerForum || undefined,
    dataRicezioneAttoConiuge1: subjectAvvoc3?.generality?.dateCommunication
      ? subjectAvvoc3?.generality?.dateCommunication.toFormat('yyyy-MM-dd')
      : undefined,
    dataRicezioneAttoConiuge2: subjectAvvoc4?.generality?.dateCommunication
      ? subjectAvvoc4?.generality?.dateCommunication.toFormat('yyyy-MM-dd')
      : undefined,
    protocolloAttoConiuge1: subjectAvvoc3?.generality?.protocol || undefined,
    protocolloAttoConiuge2: subjectAvvoc4?.generality?.protocol || undefined,
  };
};
